/**
 * Which of Data curation's tabs this person opens (M286 idea 16): each keeps the gate of the page it replaced —
 * Reference Data on feature:settings_reference_data, Property Types on feature:settings_property_types_uses, and
 * Property-Type Fields on feature:settings_reference_data plus a Manager+ role (the API's
 * property-type-defs-admin-guard). The hub entry shows when one tab does; settings search lists only these tabs.
 * The API decides every write itself; this is UX, not security.
 */
import { useMemo } from 'react';
import { MANAGER_PLUS_ROLES } from '@aiga/app-config/permissions';
import { useAuth } from '@/contexts/AuthContext';
import { useFeatureAccess } from '@/hooks/useFeatureAccess';
import { DATA_CURATION_TABS, type DataCurationTabId } from './settingsTabs';

export function useDataCurationTabs(): DataCurationTabId[] {
  const { role } = useAuth();
  const canReferenceData = useFeatureAccess('settings_reference_data');
  const canPropertyTypes = useFeatureAccess('settings_property_types_uses');
  const isManager = !!role?.name && MANAGER_PLUS_ROLES.has(role.name);
  return useMemo(() => {
    const opens: Record<DataCurationTabId, boolean> = { lookups: canReferenceData, types: canPropertyTypes, fields: canReferenceData && isManager };
    return DATA_CURATION_TABS.filter((t) => opens[t.id]).map((t) => t.id);
  }, [canReferenceData, canPropertyTypes, isManager]);
}
